import { Button, Card, Empty, Form, Input, Layout, message, Modal, Pagination, Space, Spin, Typography, Divider, Popconfirm } from 'antd'
import { Content } from 'antd/lib/layout/layout'
import { EditOutlined, DeleteOutlined, FileTextTwoTone } from '@ant-design/icons'
import { useEffect, useState } from 'react'
import dayjs from 'dayjs'
import SiderMenuMain from '../../../components/SiderMenuMain'
import NavBreadcrumb from '../../../components/NavBreadcrumb'
import NavHeader from '../../../components/NavHeader'
import NavFooter from '../../../components/NavFooter'
import AxiosUtil from '../../../utils/AxiosUtil'
import IsRender from '../../../components/isRender'
import styles from './help.module.less'
import { useHistory } from 'react-router'

type IDoc = { id?: number; title: string; summary: string }
type IDocDetail = { id: number; announcementId?: any; publishDate?: any; title: string; summary: string }
export type IDocList = { total: number; list: IDocDetail[] }

const pageSize = 10
const initDocList: IDocList = { total: 1, list: [] }
const crumb = [{ name: '系统管理' }, { name: '帮助文档' }]

const editDoc = (params: IDoc, callback: (suc: boolean, dat: IDocDetail) => void) => {
  AxiosUtil.AxiosRequest('/api/announcement/edit', params, callback)
}

export default function Help() {
  const history = useHistory()
  const [addForm] = Form.useForm() // 修改或添加文档集时的 form 表单
  const [pageIndex, setPageIndex] = useState(1) // 当前页码
  const [loading, setLoading] = useState(false) // 是否加载中
  const [docList, setDocList] = useState<IDocList>(initDocList) // 获取到项目文档列表数据
  const [curDoc, setCurDoc] = useState<IDocDetail>({} as IDocDetail) // 当前选中的项目文档项
  const [isModalOpen, setIsModalOpen] = useState(false) // 修改项目文档名称的 Modal 是否打开

  /** 加载项目文档列表 */
  const loadDocList = (pageIndex: number, pageSize: number) => {
    setLoading(true)
    AxiosUtil.AxiosRequest('/api/announcement/list', { pageIndex, pageSize, type: 2 }, (suc, dat) => {
      if (suc) setDocList(dat)
      else setDocList(initDocList)
      setLoading(false)
    })
  }
  /** 点击项目文档的删除按钮 */
  const onClickDel = (item: IDocDetail) => {
    AxiosUtil.AxiosRequest('/api/announcement/delete', { id: item.id }, (suc) => {
      if (suc) {
        message.success('删除成功 !')
        loadDocList(pageIndex, pageSize)
      } else message.error('删除失败 !')
    })
  }
  /** 点击项目文档的编辑按钮 */
  const onClickEdit = (item: IDocDetail) => {
    setCurDoc(item)
    setIsModalOpen(true)
    addForm.setFieldsValue(item)
  }
  /** 编辑或新增的 form 完成的回调 */
  const onFormFinish = (values: IDoc) => {
    editDoc(values, (suc, dat) => {
      if (suc) {
        if (curDoc.id) {
          if (pageIndex === 1) loadDocList(pageIndex, pageSize)
          else setPageIndex(1) // pageIndex 发生变化, 自动加载 noticeList
          onHiddenModal()
          message.success('项目文档' + (curDoc.id ? '修改' : '添加') + '成功 !')
        } else history.push({ pathname: '/admin/help/' + dat.id })
      }
    })
  }
  /** 点击添加项目文档按钮 */
  const onAddDoc = () => setIsModalOpen(true)
  /** 隐藏 Modal */
  const onHiddenModal = () => {
    setCurDoc({} as IDocDetail)
    setIsModalOpen(false)
    addForm.resetFields()
  }
  /** Card 头部的额外内容 */
  const cardExtra = (
    <Button type={'primary'} onClick={onAddDoc}>
      添加平台文档
    </Button>
  )

  useEffect(() => loadDocList(pageIndex, pageSize), [pageIndex])

  return (
    <Layout>
      <NavHeader />
      <Content className={'main-body'}>
        <Layout id={styles.help}>
          <SiderMenuMain />
          <Content className={'main-content ' + styles.notice}>
            <NavBreadcrumb itemList={crumb} />
            <Spin spinning={loading}>
              <Card title={'平台文档'} className={'notice-box'} extra={cardExtra} headStyle={{ fontWeight: 700 }} bodyStyle={{ minHeight: '100%' }}>
                <IsRender isRender={docList.total} children2={<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}>
                  <ul className={'notice-box-ul'}>
                    {docList.list.map((item) => (
                      <li key={item.id} className={'notice-item'}>
                        <a className={'item-content-box'} href={`#/admin/help/${item.id}`}>
                          <div className={'item-content-title'}>
                            <FileTextTwoTone style={{ fontSize: 20 }} />
                            &nbsp; &nbsp;{item.title}
                          </div>
                          <div>{item.publishDate && dayjs(item.publishDate).format('YYYY-MM-DD')}</div>
                        </a>
                        <div className={'item-operate-box'}>
                          <Space size={10} split={<Divider type={'vertical'} />}>
                            <Popconfirm title={'确认删除该平台文档吗 ?'} onCancel={onHiddenModal} onConfirm={() => onClickDel(item)}>
                              <Typography.Link>
                                <DeleteOutlined />
                              </Typography.Link>
                            </Popconfirm>
                            <Typography.Link onClick={() => onClickEdit(item)}>
                              <EditOutlined />
                            </Typography.Link>
                          </Space>
                        </div>
                      </li>
                    ))}
                  </ul>
                  <Pagination
                    current={pageIndex}
                    pageSize={pageSize}
                    total={docList.total}
                    onChange={setPageIndex}
                    showSizeChanger={false}
                    className={'pagination'}
                  />
                </IsRender>
              </Card>
            </Spin>
            <Modal
              width={600}
              destroyOnClose
              onOk={addForm.submit}
              visible={isModalOpen}
              onCancel={onHiddenModal}
              okText={curDoc.id ? '修改' : '添加'}
              title={(curDoc.id ? '修改' : '添加') + '平台文档'}
            >
              <Form form={addForm} labelCol={{ span: 4 }} wrapperCol={{ span: 20 }} onFinish={onFormFinish}>
                <Form.Item hidden name={'id'}>
                  <Input />
                </Form.Item>
                <Form.Item hidden name={'type'} initialValue={2}>
                  <Input />
                </Form.Item>
                <Form.Item label={'项目名称'} name={'title'} rules={[{ required: true, message: '请输入项目名称' }]}>
                  <Input placeholder={'请输入项目名称 !'} />
                </Form.Item>
                <Form.Item label={'文档描述'} name={'summary'}>
                  <Input.TextArea style={{ height: 200, resize: 'none' }} placeholder={'请输入项目文档描述 !'} />
                </Form.Item>
              </Form>
            </Modal>
          </Content>
        </Layout>
      </Content>
      <NavFooter />
    </Layout>
  )
}
